// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"a9b4fd90","323":"5f0e006d","381":"2868c62b","437":"8d425fd5","477":"f4196865","515":"d029ebc9","774":"5bb7264d","833":"a682749a","852":"d245ca2c","858":"4b645246","925":"687bd894"}[chunkId] + ".chunk.js";
};